import React, { useState, useEffect, useRef } from 'react'

export default function AnimatedNumber({ value, suffix = '', duration = 1800 }) {
  const [n, setN] = useState(0)
  const ref = useRef(null)
  const startedRef = useRef(false)
  useEffect(() => {
    if (!ref.current) return
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && !startedRef.current) {
          startedRef.current = true
          const start = performance.now()
          const tick = (t) => {
            const p = Math.min(1, (t - start) / duration)
            const eased = 1 - Math.pow(1 - p, 3)
            setN(Math.round(value * eased))
            if (p < 1) requestAnimationFrame(tick)
          }
          requestAnimationFrame(tick)
        }
      })
    }, { threshold: 0.3 })
    obs.observe(ref.current)
    return () => obs.disconnect()
  }, [value, duration])
  return <span ref={ref}>{n.toLocaleString()}{suffix}</span>
}
